const nrbRegex = /^\d{26}$/;
const ibanRegex = /^PL\d{26}$/;


// Przykład użycia:
export const isValidBankAccount = (accountNumber) => {
    const formatted = accountNumber.replaceAll(" ", "").slice(0, -1);
    return nrbRegex.test(formatted) || ibanRegex.test(formatted);
};
